import { useAtomValue } from "jotai";
import type { NextPage, PageProps } from "next";
import { useEffect } from "react";

import { AppFooter } from "scmp-app/components/app-footer";
import { PageSeo } from "scmp-app/components/meta";
import { AddingTopicsAndAuthors } from "scmp-app/components/my-news/adding-topics-and-authors";
import { SettingUpAlert } from "scmp-app/components/my-news/setting-up-alert";
import { WhatIsMynews } from "scmp-app/components/my-news/what-is-mynews";
import { trackingAtom } from "scmp-app/components/tracking";

import { MynewsLogo, PageContainer, PageWrapper, Title } from "./styles";

const AboutMynewsPage: NextPage<PageProps> = () => {
  const { trackPageView } = useAtomValue(trackingAtom);

  const seo = {
    description:
      "Your source for credible news and authoritative insights from Hong Kong, China and the world.",
    openGraph: {
      description:
        "Your source for credible news and authoritative insights from Hong Kong, China and the world.",
      title: "About My News",
    },
    title: "About My News",
  };

  useEffect(() => {
    trackPageView?.();
  }, [trackPageView]);

  return (
    <>
      <PageSeo {...seo} />
      <PageContainer>
        <PageWrapper>
          <Title>
            ABOUT <MynewsLogo />
          </Title>
          <WhatIsMynews />
          <AddingTopicsAndAuthors />
          <SettingUpAlert />
        </PageWrapper>
      </PageContainer>
      <AppFooter />
    </>
  );
};

AboutMynewsPage.displayName = "AboutMynewsPage";
const pageProps: PageProps = {
  contentConfiguration: {
    responsivePadding: {
      desktopUp: 0,
      mobileUp: 0,
      tabletUp: 0,
    },
  },
};

AboutMynewsPage.getInitialProps = () => ({
  animateKey: "about-mynews",
  ...pageProps,
});

export default AboutMynewsPage;
